export const iconFontAwesomeFoodBeverageJarWheat = (
	<i className="fa-solid fa-jar-wheat"></i>
);
